module.exports = __webpack_public_path__ + "static/media/img_3803.cf2eb807.jpg";